import React from 'react';
import { Button, Offcanvas, OffcanvasBody } from 'reactstrap';

/* Matches the feedback drawer on the service order details page so both
   render identically. */
const getRatingColor = (rating) => {
  const value = Number(rating);
  if (value < 3) return '#dc3545';
  if (value === 3) return '#f5b301';
  return '#28a745';
};

const renderStars = (rating, size = '1rem') => {
  const value = Math.round(Number(rating) || 0);
  const color = getRatingColor(rating);
  return [1, 2, 3, 4, 5].map((star) => (
    <i
      key={star}
      className={`mdi ${star <= value ? 'mdi-star' : 'mdi-star-outline'}`}
      style={{ color, fontSize: size }}
    ></i>
  ));
};

const ServiceFeedbackDetailsOffcanvas = ({ isOpen, toggle, feedback }) => (
  <Offcanvas
    isOpen={isOpen}
    toggle={toggle}
    direction="end"
    style={{ width: '480px', backgroundColor: '#ffffff' }}
  >
    <div className="p-4 border-bottom bg-white sticky-top shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-0">
        <div className="d-flex align-items-center gap-3">
          <div className="bg-warning bg-opacity-10 p-2 rounded-3">
            <i className="mdi mdi-star text-warning fs-4"></i>
          </div>
          <div>
            <h5 className="fw-bold mb-0 text-dark">Service Feedback</h5>
            <p className="text-muted small mb-0">
              {feedback?.complaint_no || feedback?.reference_no}
            </p>
          </div>
        </div>
        <Button
          type="button"
          className="btn-close"
          onClick={toggle}
          aria-label="Close"
          style={{ backgroundColor: 'transparent', border: 'none' }}
        ></Button>
      </div>
    </div>

    <OffcanvasBody>
      {feedback ? (
        <>
          {/* Overall rating */}
          <div className="text-center border rounded-3 p-3 mb-4 bg-light">
            <div className="mb-1">{renderStars(feedback?.rating, '1.6rem')}</div>
            <h4
              className="fw-bold mb-0"
              style={{ color: getRatingColor(feedback?.rating) }}
            >
              {feedback?.rating} / 5
            </h4>
            {feedback?.created_at && (
              <p className="text-muted small mb-0 mt-1">
                Submitted on {feedback?.created_at}
              </p>
            )}
          </div>

          {/* Questions & answers */}
          {Array.isArray(feedback?.questions) &&
            feedback.questions.map((q, idx) => (
              <div key={idx} className="mb-3">
                <p className="fw-semibold mb-1">
                  {idx + 1}. {q?.question}
                </p>
                {q?.type === 'rating' ? (
                  <div>{renderStars(q?.answer)}</div>
                ) : q?.answer ? (
                  <span
                    className="badge border px-2 py-1"
                    style={{
                      backgroundColor: '#f1f3f5',
                      color: '#495057',
                      borderColor: '#ced4da',
                    }}
                  >
                    {q.answer}
                  </span>
                ) : (
                  <span className="text-muted small">No answer</span>
                )}
              </div>
            ))}

          {/* Customer remarks */}
          <div className="mt-4">
            <p className="fw-semibold mb-1">Customer Remarks</p>
            {feedback?.comment ? (
              <div className="border rounded-3 p-3 bg-light">
                {feedback.comment}
              </div>
            ) : (
              <span className="text-muted small">No remarks</span>
            )}
          </div>
        </>
      ) : (
        <div className="text-center py-5">
          <i
            className="mdi mdi-star-outline text-muted"
            style={{ fontSize: '2.5rem' }}
          ></i>
          <h6 className="text-dark fw-bold mt-2">No Feedback Available</h6>
        </div>
      )}
    </OffcanvasBody>
  </Offcanvas>
);

export default ServiceFeedbackDetailsOffcanvas;
